import React, { useEffect, useMemo, useState} from "react";

import PropTypes from 'prop-types';


// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../../../component/Logo/DrawerLogo';
import ProfileSection from './ProfileSection';
import Breadcrumbs from '../../../component/BreadCrumbs/Index';
import navigation from '../../../menu-items/index';
import SessionExpire from '../../../component/Modal/SessionExpire';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "../../../store/actions";

// assets
import { IconMenu2 } from '@tabler/icons';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const aiwritemate = useSelector((state) => state.aiwritemate);
    const { tokenExpire } = aiwritemate;
    const [sessionOpen, setSessionOpen] = useState(false);

    const handleSessionExpire=async()=>{        
        dispatch({ type: LOGOUT });
          
        navigate("/")
        setSessionOpen(false)
    }
    const theme = useTheme();
    useEffect(() => {  
 // Set a timeout to update the message state after 5 seconds
        const timeoutId = setTimeout(() => {
            if (Date.now() >= Number(tokenExpire) * 1000){
                setSessionOpen(true)            
            } 
          }, 1000);
       // Return a cleanup function to clear the timeout
    return () => {
        clearTimeout(timeoutId);
      };
    }, []);
    return (
        <>
            {/* logo & toggler button */}
            <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >

<Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
               
                {/* <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}> */}
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: "#fff",
                            color: theme.palette.primary.main,
                            '&:hover': {
                                background: "#fff",
                                color: theme.palette.primary.main
                            }
                        }}
                        onClick={()=>handleLeftDrawerToggle()}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.5rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
          <Breadcrumbs  navigation={navigation} icon title rightAlign />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
           
            <ProfileSection />
            <SessionExpire
                     open={sessionOpen}
        title="Session has been Expired!"
        description="Please re-login to continue"
        btnText="Re-Login"
        confirm={handleSessionExpire}
      />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;